import Store from '@/store/store';

export class SignaturePdfData {
    constructor(obj = {}) {
        const appSigningSettings = Store.getters.appSigningSettings || {};

        this.contents = obj.contents; // Base64 file content
        this.thumbprint = obj.thumbprint || '' // Ако съществува няма да изискава избор на сертификат, а ще го намери в store-а
        this.options = obj.options || {};

        if (!this.options.hasOwnProperty('reason')) {
            this.options.reason = appSigningSettings.defaultPdfReason || null; // Sets the signing reason.
        }

        if (!this.options.hasOwnProperty('contact')) {
            this.options.contact = appSigningSettings.defaultPdfContact || null; // Sets the signing contact.
        }

        if (!this.options.hasOwnProperty('location')) {
            this.options.location = appSigningSettings.defaultPdfLocation || null; // Sets the signing location.
        }

        if (!this.options.hasOwnProperty('visualizatonType')) {
            // annotation - търси  panel с въведено BookmarkId, DocumentMapText и Action(Navigate to bookmarkId). Ще използва размерите на панела за да определи rectangle нa подписа.
            // rectangle - По подразбиране. Очаква подадено rectangle или взима някакво по подразбиране в локалния сървър.
            this.options.visualizatonType = appSigningSettings.defaultPdfSignatureVisualizatonType || '';
        }

        if (!this.options.hasOwnProperty('rectangle')) {
            this.options.rectangle = appSigningSettings.defaultPdfRectagle || null; // Coords of the signature rectangle (comma separated string). Deafult value: llx = 10, lly = 10, urx = Math.Min(pageSize.Width / 3, 250), ury = Math.Max(pageSize.Width / 5, 110)
        }

        if (!this.options.hasOwnProperty('isVisible')) {
            this.options.isVisible = appSigningSettings.defaultPdfSignatureVisualizationIsVisible || true; // Sets the signature to be visible. It creates a new visible signature field.
        }

        if (!this.options.hasOwnProperty('xStep')) {
            this.options.xStep = appSigningSettings.defaultPdfXStep;
        }

        if (!this.options.hasOwnProperty('yStep')) {
            this.options.yStep = appSigningSettings.defaultPdfYStep;
        }
    }
}
